var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.98337C3.91111 4.98337 3.82489 4.9667 3.74133 4.93337C3.65778 4.90003 3.58844 4.85559 3.53333 4.80003L0.466666 1.73337C0.344444 1.61114 0.283333 1.45559 0.283333 1.2667C0.283333 1.07781 0.344444 0.922255 0.466666 0.800032C0.588888 0.67781 0.744444 0.616699 0.933333 0.616699C1.12222 0.616699 1.27778 0.67781 1.4 0.800032L4 3.40003L6.6 0.800032C6.72222 0.67781 6.87778 0.616699 7.06667 0.616699C7.25556 0.616699 7.41111 0.67781 7.53333 0.800032C7.65555 0.922255 7.71667 1.07781 7.71667 1.2667C7.71667 1.45559 7.65555 1.61114 7.53333 1.73337L4.46667 4.80003C4.4 4.8667 4.32778 4.91403 4.25 4.94203C4.17222 4.97003 4.08889 4.98381 4 4.98337Z",
    fill: "#5E5E62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDown);
export default __webpack_public_path__ + "static/media/vector-down.08aaea689da080facddd1f9121830db5.svg";
export { ForwardRef as ReactComponent };